import React, { useEffect, useState } from 'react'
import { getDataWithTypeForSelect } from '../../lib/parameters'
import {  updateData, getStudentIdData } from '../../lib/studentcurriculumtable'
import { useAuth } from '../../_helper/Auth/AuthProvider'
import { ToastNotification } from '../Lessons/CourseReport/CourseReportComponents'

const CurriculumTable = ({ studentId, isStudentView = false }) => {
	const [selectedCells, setSelectedCells] = useState([])
	const [parameters, setParameters] = useState([])
	const [recId, setRecId] = useState(0)
	const [loading, setLoading] = useState(true)
	const [error, setError] = useState('')
	const [toastMessage, setToastMessage] = useState('')
	const [showToast, setShowToast] = useState(false)

	const showToastMessage = (message) => {
		setToastMessage(message)
		setShowToast(true)
		setTimeout(() => setShowToast(false), 3000)
	}

	const { user } = useAuth()
	const effectiveStudentId = studentId || user?.id

	const months = ['Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May']

	const getParameterData = async () => {
		try {
			setError('')
			const info = await getDataWithTypeForSelect('CIRCULUM')
			setParameters(info)
		} catch (error) {
			console.error('Error fetching parameters:', error)
			setError('Failed to load curriculum parameters')
		}
	}

	const getSelectedData = async () => {
		try {
			const info = await getStudentIdData(effectiveStudentId)
			if (info.length > 0) {
				setSelectedCells(info[0].jdata || [])
				setRecId(info[0].id)
			}
		} catch (error) {
			console.error('Error fetching selected data:', error)
			setError('Failed to load curriculum data')
		}
	}

	useEffect(() => {
		const loadData = async () => {
			setLoading(true)
			await Promise.all([getParameterData(), getSelectedData()])
			setLoading(false)
		}

		if (effectiveStudentId) {
			loadData()
			setShowToast(false)
		}
	}, [effectiveStudentId])

	const buttonClick = async () => {
		try {
			setLoading(true)
			if (recId > 0) {
				await updateData({
					id: recId,
					jdata: selectedCells
				})
			}
			showToastMessage('Update successful!')
			window.scrollTo(0, 0)
		} catch (error) {
			console.error('Error updating curriculum:', error)
			setError('Failed to update curriculum data')
		} finally {
			setLoading(false)
		}
	}

	const handleCellClick = (month, itemIndex) => {
		if (isStudentView) return // Students can't edit

		const cellIdentifier = `${month}-${itemIndex}`
		const isSelected = selectedCells.includes(cellIdentifier)

		if (isSelected) {
			setSelectedCells(selectedCells.filter((id) => id !== cellIdentifier))
		} else {
			setSelectedCells([...selectedCells, cellIdentifier])
		}
	}

	return (
		<div className="card mb-4 shadow-sm" style={{ borderRadius: '8px' }}>
			<ToastNotification show={showToast} message={toastMessage} onClose={() => setShowToast(false)} />
			<div className="card-header border-bottom d-flex justify-content-between align-items-center">
				<div className="d-flex align-items-center">
					<button
						type="button"
						className="btn btn-link p-0 me-2"
						data-bs-toggle="collapse"
						data-bs-target="#collapseCurriculum"
						aria-expanded="false"
						aria-controls="collapseCurriculum"
					>
						<i className="fa fa-chevron-down"></i>
					</button>
					<h5 className="mb-0 d-inline-block">Curriculum Timeline</h5>
				</div>
			</div>
			<div className="collapse" id="collapseCurriculum">
				<div className="card-body">
					{error && (
						<div className="alert alert-danger alert-dismissible fade show" role="alert">
							<strong>Error:</strong> {error}
							<button type="button" className="btn-close" onClick={() => setError('')} aria-label="Close"></button>
						</div>
					)}

					{loading ? (
						<div className="text-center">
							<div className="spinner-border" role="status">
								<span className="visually-hidden">Loading...</span>
							</div>
							<p className="mt-2">Loading curriculum data...</p>
						</div>
					) : (
						<div className="curricullum_parent">
							<div className="table-responsive">
								<table className="table table-bordered curriculum_table">
									<thead>
										<tr>
											<th>Curriculum</th>
											{months.map((month, index) => (
												<th key={index} className="text-center">
													{month}
												</th>
											))}
										</tr>
									</thead>
									<tbody>
										{parameters.map((item) => (
											<tr key={item.value}>
												<td className="fw-bold">{item.label}</td>
												{months.map((month) => {
													const cellIdentifier = `${month}-${item.value}`
													const isSelected = selectedCells.includes(cellIdentifier)
													return (
														<td
															key={cellIdentifier}
															className={`text-center ${isSelected ? 'table-success' : ''} ${!isStudentView ? 'cursor-pointer' : ''}`}
															onClick={() => handleCellClick(month, item.value)}
															style={{ minWidth: '60px', height: '40px' }}
														>
															{isSelected && <i className="fa fa-check text-success"></i>}
														</td>
													)
												})}
											</tr>
										))}
									</tbody>
								</table>
							</div>

							{!isStudentView && (
								<div className="d-flex justify-content-between mt-3">
									<div></div>
									<button onClick={buttonClick} className="btn btn-primary" disabled={loading}>
										<i className="fa fa-save me-2"></i>
										{loading ? 'Updating...' : 'Update Timeline'}
									</button>
								</div>
							)}
						</div>
					)}
				</div>
			</div>
		</div>
	)
}

export { CurriculumTable }
